import { FC, PropsWithChildren } from "react";
import { Link } from "react-router-dom";

import __ from "web/Layout/Translations";

import isExternal from "web/utils/data/validator/url/isExternal";
import processAnchorHref from "web/utils/system/url/processAnchorHref";

export interface IAnchorProps {
  to: string;
  title?: string;
  onClick?: () => void;
  className?: string;
  dataT1?: string;
  ariaLabel?: string;
  dataGtm?: string;
}

const Anchor: FC<PropsWithChildren<IAnchorProps>> = ({
  to,
  title,
  onClick = () => {},
  className = "",
  dataT1 = "anchor",
  children = "",
  ariaLabel = undefined,
  dataGtm = undefined,
}) => {
  const newHref = processAnchorHref(to);

  return isExternal(newHref) ? (
    <a
      target="_blank"
      rel="noreferrer"
      href={newHref}
      title={title}
      className={className}
      data-t1={dataT1}
      onClick={onClick}
      aria-label={ariaLabel}
      data-gtm={dataGtm}
    >
      {children}
      <span className="visually-hidden">
        {" "}
        - {__("Link otwiera się w nowej karcie")}
      </span>
    </a>
  ) : (
    <Link
      to={newHref}
      title={title}
      onClick={onClick}
      className={className}
      data-t1={dataT1}
      data-t2={title}
      aria-label={ariaLabel}
      data-gtm={dataGtm}
    >
      {children}
    </Link>
  );
};

export default Anchor;
